module.exports = global["surveylab_form_invisibleRecaptcha"] = require("-!/app/node_modules/ts-loader/index.js??ref--4!./invisible-recaptcha.ts");